
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gift/checkout",
      function () {
        return require("private-next-pages/gift/checkout.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gift/checkout"])
      });
    }
  